import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=13bdd2d4&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=13bdd2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdd2d4",
  null
  
)

export default component.exports